import { render, staticRenderFns } from "./Authenticated.vue?vue&type=template&id=55d5a3a7&scoped=true&"
import script from "./Authenticated.vue?vue&type=script&lang=js&"
export * from "./Authenticated.vue?vue&type=script&lang=js&"
import style0 from "./Authenticated.vue?vue&type=style&index=0&id=55d5a3a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d5a3a7",
  null
  
)

export default component.exports